import React from 'react';
import { Box, Dialog, IconButton } from '@radix-ui/themes';

import { ClearIcon } from 'shared/icons';
import './dialog-header.css';

export const DialogHeader = ({
    title,
    description,
}: {
    title?: string;
    description?: string;
}) => {
    return (
        <header className="rAdix-dialog__header">
            <Box>
                <Dialog.Title weight="medium">{title}

                     {description ? <Dialog.Description color='gray'>{description}</Dialog.Description> : null}
                </Dialog.Title>
               
            </Box>

            <Dialog.Close>
                <IconButton variant="ghost" size="1" color="gray" radius="full">
                    <ClearIcon width="20" height="20" />
                </IconButton>
            </Dialog.Close>
        </header>
    );
};
